import { render } from "./checkbox-template.vue?vue&type=template&id=0a3b67c8&lang=true"
import script from "./checkbox-template.vue?vue&type=script&lang=js"
export * from "./checkbox-template.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__